import moment from 'moment-timezone';

/**
 * Function that returns the correct string of the countdown from 100 minutes before the game starts.
 * If the time is higher than 100 it caps at 99:59 and the lowest it goes is 00:00
 * @param  {string | Date | moment.Moment} targetDate is the start date of the game
 * @return {string} Any number between 99:59 and 00:00
 */
export const calculateTimeLeft = (
  targetDate: string | Date | moment.Moment
): string => {
  const now = moment();
  const target = moment(targetDate);

  if (target.isSameOrBefore(now)) {
    return '00:00';
  }

  const diff = target.diff(now);
  const duration = moment.duration(diff);

  const minutes = Math.floor(duration.asMinutes());

  if (minutes >= 100) {
    return '99:59';
  }

  const seconds = String(duration.seconds()).padStart(2, '0');

  return `${minutes}:${seconds}`;
};
